import { DocMetaData } from "./docMetaData";
import { GetDocMetaDataResponse } from "./getDocMetaData"


export const isBlank = (v?: string | null): boolean => 
    v == null || v.trim() === "" || v.trim().toLowerCase() === "none" || v.trim().toLowerCase() === "null";


export const parseDateUtility = (v?: unknown): Date | string | null => {
    if(typeof v === "string" && !isBlank(v)){
        const d = new Date(v);
        console.log("parseUtility triggered value is ", d)
        return Number.isNaN(d.getTime()) ? null : d;
    }

    if(v instanceof Date && !Number.isNaN(v.getTime())) return v;
    return null;
    
   
};

export const transformApiResponse = (
    response: GetDocMetaDataResponse,
file: File ): DocMetaData => {
    return {
        file,
        fileName: response.fileName ?? file.name,
        entityType: isBlank(response.entityType) ? "" : response.entityType,
        entity: isBlank(response.entity) ? "" : response.entity,
        documentType: isBlank(response.documentType) ? "" : response.documentType,
        authorDate: isBlank(response.authorDate) ? "" : response.authorDate,
        documentDate: isBlank(response.documentDate) ? "" : response.documentDate,

    }
};

